import { text } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'text',
  label: 'Text',
  category: 'Data Display',
  image: text
};
